import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CTAButtonProps = {
  label: string;
  id?: string;
  note?: string;
  tone?: "light" | "dark";
  className?: string;
};
export function CTAButton({
  label,
  id,
  note,
  tone = "light",
  className = ""
}: CTAButtonProps) {
  return <div className={`mx-auto w-full max-w-xl ${className}`} data-id="element-103" data-mp="2fys6umpqy3k0">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-[18px] text-center text-[15px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(23,128,72,0.75)] ring-1 ring-inset ring-white/15 transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-light sm:py-5 sm:text-lg" data-id="element-104" data-mp="2tyuny6q8csy7">
        <span data-id="element-105" data-mp="38paappyao8yh">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-106" data-mp="38q3kz0wgpgld" />
      </a>
      {note && <p className={`mt-3 text-center text-[13px] leading-relaxed sm:text-sm ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-107" data-mp="1dartcyxy4xse">
          {note}
        </p>}
    </div>;
}